/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Logger } from '../logger';
import { Request } from '../request';

export class XHRRequest implements Request {
  constructor(private url: string) {}

  public isAvailable(): boolean {
    return typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
  }

  public send(data: string): boolean {
    Logger.info('send by xhr');

    try {
      const req = new XMLHttpRequest();
      req.open('POST', this.url, true);
      req.withCredentials = true;
      req.overrideMimeType('application/json');
      req.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
      req.onreadystatechange = (): void => {
        if (req.readyState === 4) {
          // XMLHttpRequest.DONE == 4, except in safari 4
          if (req.status !== 200) {
            Logger.error(`Bad HTTP status: ${req.status} ${req.statusText}`);
          }
        }
      };
      req.send(data);

      return true;
    } catch (e) {
      Logger.error(e);

      return false;
    }
  }
}
